import React, { useState } from "react";
import axios from "axios";
import excelIcon from "../images/icons/excel 1 (1).png";
import Tippy from "@tippyjs/react";

const DownloadExcel = (props) => {
  const fileLink = props.link;
  const filterData = props.data;
  const fileName = props.filename;
  const [excelLoader, setExcelLoader] = useState(false);

  const handleDownload = async () => {
    setExcelLoader(true);
    try {
      let response = await axios.post(
        fileLink,
        { ...filterData, download: 1, paginate: 0 },
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(localStorage.getItem("inventory"))?.token
            }`,
          },
          responseType: "arraybuffer",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName + ".xlsx");
      document.body.appendChild(link);
      link.click();
      setExcelLoader(false);
    } catch (e) {
      setExcelLoader(false);
    }
  };

  return (
    // <Tippy content="Download" trigger="mouseenter">
    //   <img
    //     src={excelIcon}
    //     className="img-fluid mx-2 icon"
    //     width="30px"
    //     height="30px"
    //     alt=""
    //     role="button"
    //     onClick={handleDownload}
    //   />
    // </Tippy>
    <div>
      <button
        type="button"
        className="btn btn-primary py-0"
        style={{
          background: "#4263eb",
          borderRadius: "8px",
          fontWeight: "600",
          fontSize: "14px",
          lineHeight: "42px",
          color: "#ffffff",
          height: "35px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={handleDownload}
      >
        {excelLoader ? (
          <span className="spinner-border spinner-border-sm me-2"></span>
        ) : (
          <img src={excelIcon} className="img-fluid me-2" alt="" />
        )}
        Download
      </button>
    </div>
  );
};

export default DownloadExcel;
